// Establecer un contexto

import { createContext } from "react";

const CountryContext = createContext(null)

export default CountryContext